<!-- Error page-->
<div class="misc-wrapper">
  <a class="brand-logo" routerLink="/">
    <img src="assets/images/misc/logo.png" alt="brand-logo" height="120" />
  </a
  >
  <div class="misc-inner p-2 p-sm-3">
    <div class="w-100 text-center">
      <h2 class="mb-1">Pagina no encontrada 🕵🏻‍♀️</h2>
      <a class="btn btn-black mb-2 btn-sm-block" routerLink="/" rippleEffect>Ir al inicio</a
      ><img
        class="img-fluid"
        [src]="
          coreConfig.layout.skin === 'dark' ? 'assets/images/pages/error-dark.svg' : 'assets/images/pages/error.svg'
        "
        alt="Error page"
      />
    </div>
  </div>
</div>
<!-- / Error page-->
